<template>

<section>

<div class="light">

  <div class="container mt-0 pt-3 warning-light">

    <h4>Containers</h4>
    <br>

    Five (5) 'container' classes/component are available in SymCSS:
    <br><br>
    <ol class='ml-4'>
      <li><sym-link to="#container"><b>container</b></sym-link> - intended as an 'outer container' for hosting other types of container elements.
          As such, it has no top and bottom paddings, with only enough left and right paddings (varies with screen size),
          but with default top and bottom margins of 1rem (16px). It's background color is transparent by default and it
          spans up to 94% of the screen width (maximum width) and is always centered.
          <br>
          <br>Note: The text of this section is inside a div (with class 'container'), styled with yellow background to show
          the container area. The area with a white background is a bare div element serving as a mockup 'page'
          to illustrate the coverage of the 'container' element.
          <br><br>
      </li>

      <li><sym-link to="#board"><b>board</b></sym-link> - styles a bare div into a 'whiteboard' (background color is set to white) with generous amount of paddings on all sides.
          It sports a border with 'rounded' (curved) corners and takes up the entire width of its parent container by default (excluding padding).
          Use it to construct home pages if lots of white space is desired, call-to-action boxes, or page sections.
          <br><br>
      </li>

      <li><sym-link to="#box-border"><b>box-border</b></sym-link> - a hybrid of 'container' and 'board', this class has no background color (transparent), having a lightgray rounded
          (curved) border, spans the full width of it's parent element, with minimal padding on all sides, and a bottom margin of 6px.
          <br><br>
      </li>

      <li><sym-link to="#media"><b>media</b></sym-link> - used to build complex and repetitive components where some media (image, for example) is positioned alongside content
          that doesn’t wrap around said media.
          <br><br>
      </li>

      <li><b>card</b> - an all-purpose component ('sym-card' tag) with optional header, footer, title, subtitle, and image. By default, it takes
          the full width of it's parent element, so a single card will need additional styling to set it's intended width.
          <br><br>
      </li>
    </ol>
  </div>

</div>

<div>
  <div id="container" class="container border-light">
    <h5>● Container - default settings:</h5>
    <h6>
      transparent background, no top/bottom paddings, left/right padding (12px), top and bottom margins (1rem=16px), no border
      <br><br>
    </h6>
    Note: white border added to illustrate the container area
  </div>

  <div class="container">
    <textarea class="code mb-5 border-dark" disabled wrap="off" spellcheck="false" rows="10">
    <div class="container border-light">
      <h5>● Container - default settings:</h5>
      <h6>
        transparent background, no top/bottom paddings, left/right padding (12px), top and bottom margins (1rem=16px), no border
        <br><br>
      </h6>
      Note: white border added to illustrate the container area
    </div>
    </textarea>
  </div>

  <div id="board" class='board curved-0'>
    <h5>● Board - full-width, white background by default, no curved corners</h5>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="5">
    <div class='board curved-0'>
      <h5>● Board - full-width, white background by default, no curved corners</h5>
    </div>
    </textarea>
  </div>

  <div class="container border-light">
    <div class="board">
      <h5>● Board - inside a Container, with curved corners by default</h5>Note:
      white border added to container to reveal the board area, default left/right
      padding of the container itself, and the bottom margin (1rem=16px) of the board
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="9">
    <div class="container border-light">
      <div class="board">
        <h5>● Board - inside a Container, with curved corners by default</h5>Note:
        white border added to container to reveal the board area, default left/right
        padding of the container itself, and the bottom margin (1rem=16px) of the board
      </div>
    </div>
    </textarea>
  </div>


  <div class="container pt-3 pb-1 light">
    <div class="box-border light mb-3 p-3">
      <h4>● Boards - inside a Container (white background), with available SymCSS color schemes</h4>
    </div>
    <div class="board info">
      <h5>● Board - color scheme 'info'</h5>
    </div>
    <div class="board success">
      <h5>● Board - color scheme 'success'</h5>
    </div>
    <div class="board warning">
      <h5>● Board - color scheme 'warning'</h5>
    </div>
    <div class="board danger">
      <h5>● Board - color scheme 'danger'</h5>
    </div>
    <div class="board dark">
      <h5>● Board - color scheme 'dark'</h5>
    </div>
    <div class="board primary">
      <h5>● Board - color scheme 'primary'</h5>
    </div>
    <div class="board info-light">
      <h5>● Board - color scheme 'info-light'</h5>
    </div>
    <div class="board success-light">
      <h5>● Board - color scheme 'success-light'</h5>
    </div>
    <div class="board warning-light">
      <h5>● Board - color scheme 'warning-light'</h5>
    </div>
    <div class="board danger-light">
      <h5>● Board - color scheme 'danger-light'</h5>
    </div>
    <div class="board dark-light">
      <h5>● Board - color scheme 'dark-light'</h5>
    </div>
    <div class="board primary-light">
      <h5>● Board - color scheme 'primary-light'</h5>
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="40">
    <div class="container pt-3 pb-1 light">
      <div class="board info">
        <h5>● Board - color scheme 'info'</h5>
      </div>
      <div class="board success">
        <h5>● Board - color scheme 'success'</h5>
      </div>
      <div class="board warning">
        <h5>● Board - color scheme 'warning'</h5>
      </div>
      <div class="board danger">
        <h5>● Board - color scheme 'danger'</h5>
      </div>
      <div class="board dark">
        <h5>● Board - color scheme 'dark'</h5>
      </div>
      <div class="board primary">
        <h5>● Board - color scheme 'primary'</h5>
      </div>
      <div class="board info-light">
        <h5>● Board - color scheme 'info-light'</h5>
      </div>
      <div class="board success-light">
        <h5>● Board - color scheme 'success-light'</h5>
      </div>
      <div class="board warning-light">
        <h5>● Board - color scheme 'warning-light'</h5>
      </div>
      <div class="board danger-light">
        <h5>● Board - color scheme 'danger-light'</h5>
      </div>
      <div class="board dark-light">
        <h5>● Board - color scheme 'dark-light'</h5>
      </div>
      <div class="board primary-light">
        <h5>● Board - color scheme 'primary-light'</h5>
      </div>
    </div>
    </textarea>
  </div>


  <div id="box-border" class='box-border'>
    <h5>● Box-Border - full-width, transparent background and lightgray border by default, with curved corners and bottom margin only </h5>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="5">
    <div class='box-border'>
      <h5>● Box-Border - full-width, transparent background and lightgray border by default, with curved corners and bottom margin only </h5>
    </div>
    </textarea>
  </div>


  <div class="container light p-4">
    <div class='box-border primary-light'>
      <h5>● Box-Border - inside a Container, with 'primary-light' color scheme</h5>
      <br>
      Note: Container div colored white to illustrate the coverage area of Box-Border
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="9">
    <div class="container light p-4">
      <div class='box-border primary-light'>
        <h5>● Box-Border - inside a Container, with 'primary-light' color scheme</h5>
        <br>
        Note: Container div colored white to illustrate the coverage area of Box-Border
      </div>
    </div>
    </textarea>
  </div>

  <div class="container warning-light p-4">
    <div class='box-border border-warning'>
      <h5>● Box-Border - inside a Container colored 'warning-light' which shows through the box; border set to 'border-warning'</h5>
      <br>
      Note: border color set to 'match' prevailing background color
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="9">
    <div class="container warning-light p-4">
      <div class='box-border border-warning'>
        <h5>● Box-Border - inside a Container colored 'warning-light' which shows through the box; border set to 'border-warning'</h5>
        <br>
        Note: border color set to 'match' prevailing background color
      </div>
    </div>
    </textarea>
  </div>

  <div id="media" class='media'>
    <img class="mr-3 border-dark circle square-100" src="../../img/sample/beach.jpg">
    <div class="media-body">
      <h5>● Media - full-width, transparent background and no border, margin, and padding by default</h5>
      <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
         est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
      </p>
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="11">
    <div class='media'>
      <img class="mr-3 border-dark circle square-100" src="../../img/sample/beach.jpg">
      <div class="media-body">
        <h5>● Media - full-width, transparent background and no border, margin, and padding by default</h5>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
          est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>
    </textarea>
  </div>

  <div class="container light">
    <div class='media'>
      <img class="mr-3 border-dark circle square-100" src="../../img/sample/beach.jpg">
      <div class="media-body">
        <h5>● Media - inside Container, spans entire width of container (excluding left/right padding)</h5>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
        <br>Note: background color of parent div set to white to reveal coverage of media area
      </div>
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="14">
    <div class="container light">
      <div class='media'>
        <img class="mr-3 border-dark circle square-100" src="../../img/sample/beach.jpg">
        <div class="media-body">
          <h5>● Media - inside Container, spans entire width of container (excluding left/right padding)</h5>
          <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
             est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
          </p>
          <br>Note: background color of parent div set to white to reveal coverage of media area
        </div>
      </div>
    </div>
    </textarea>
  </div>

  <div class="container p-3 light">
    <div class="box-border success-light mb-3 p-3">
      <h5>● Media collection - inside a Container (white background)</h5>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/dimples.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm1294575/">
          <span class="lg-2 bold">Dimples Romana</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/gal.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm2933757/">
          <span class="lg-2 bold">Gal Gadot</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/natalie.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm0000204/">
          <span class="lg-2 bold">Natalie Portman</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>

  </div>

  <div class="container">
    <textarea class="code mb-5" disabled wrap="off" spellcheck="false" rows="41">
    <div class="box-border success-light mb-3 p-3">
      <h5>● Media collection - inside a Container (white background)</h5>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/dimples.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm1294575/">
          <span class="lg-2 bold">Dimples Romana</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/gal.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm2933757/">
          <span class="lg-2 bold">Gal Gadot</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>

    <div class="media mb-3">
      <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/natalie.jpg">
      <div class="media-body">
        <a href="https://www.imdb.com/name/nm0000204/">
          <span class="lg-2 bold">Natalie Portman</span>
        </a>
        <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
           est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
      </div>
    </div>
    </textarea>
  </div>

  <div class="container p-3 mb-0 light">
    <div class="box-border secondary-light mb-3 p-3">
      <h5>● Media collection - inside a Container (white background), with each Media wrapped in a Box-Border and styled
          invividually using a few SymCSS color schemes
      </h5>
    </div>

    <div class="box-border success-light mb-3">
      <div class="media">
        <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/dimples.jpg">
        <div class="media-body">
          <a href="https://www.imdb.com/name/nm1294575/">
            <span class="lg-2 bold">Dimples Romana</span>
          </a>
          <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
            est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
          </p>
        </div>
      </div>
    </div>

    <div class="box-border warning-light mb-3">
      <div class="media">
        <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/gal.jpg">
        <div class="media-body">
          <a href="https://www.imdb.com/name/nm2933757/">
            <span class="lg-2 bold">Gal Gadot</span>
          </a>
          <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
             est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
          </p>
        </div>
      </div>
    </div>

    <div class="box-border info-light mb-3">
      <div class="media">
        <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/natalie.jpg">
        <div class="media-body">
          <a href="https://www.imdb.com/name/nm0000204/">
            <span class="lg-2 bold">Natalie Portman</span>
          </a>
          <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
             est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <textarea class="code mb-4" disabled wrap="off" spellcheck="false" rows="51">
    <div class="container p-3 mb-0 light">
      <div class="box-border secondary-light mb-3 p-3">
        <h5>● Media collection - inside a Container (white background), with each Media wrapped in a Box-Border and styled
            invividually using a few SymCSS color schemes
        </h5>
      </div>

      <div class="box-border success-light mb-3">
        <div class="media">
          <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/dimples.jpg">
          <div class="media-body">
            <a href="https://www.imdb.com/name/nm1294575/">
              <span class="lg-2 bold">Dimples Romana</span>
            </a>
            <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
               est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
            </p>
          </div>
        </div>
      </div>

      <div class="box-border warning-light mb-3">
        <div class="media">
          <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/gal.jpg">
          <div class="media-body">
            <a href="https://www.imdb.com/name/nm2933757/">
              <span class="lg-2 bold">Gal Gadot</span>
            </a>
            <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
               est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
            </p>
          </div>
        </div>
      </div>

      <div class="box-border info-light mb-3">
        <div class="media">
          <img class="mr-3 border-dark circle celeb-pic" src="../../img/sample/natalie.jpg">
          <div class="media-body">
            <a href="https://www.imdb.com/name/nm0000204/">
              <span class="lg-2 bold">Natalie Portman</span>
            </a>
            <p>This is the body of the media container; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
               est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
            </p>
          </div>
        </div>
      </div>
    </div>
    </textarea>
  </div>

</div>

</section>

</template>

<script>

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples-container'

}

</script>

<style scoped>

.celeb-pic {
  width: 12%;
}

@media (max-width: 320px) {
  .celeb-pic {
    width: 28% !important;
  }
}

@media (max-width: 560px) {
  .celeb-pic {
    width: 30% !important;
  }
}

@media (max-width: 900px) {
  .celeb-pic {
    width: 16%;
  }
}

</style>
